id: '**[Entity]_ErrorMessage_Transformation_Id**'
index: '**[Entity]_ErrorMessage_Transformation_Index**'
name: '**[Entity]_ErrorMessage_Transformation_Name**'
type: Nested_SQL
metadata:
  fieldName: '__error_messages_[md5]'
  sql: 'TODO: implement this'
__notes: |-
  [SummaryOfTransformation]
